<template>
  <el-card v-loading="loading" class="h-full relative flex flex-col"> </el-card>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
export default {
  name: 'hidden-controls-center',
  data() {
    return {
      loading: true,
      //  hazardVerificationStatus 核实状态 0待核实 1已核实
      //  hiddenDangerRectificationStatus 整改状态  null 0 待整改 1整改中 2已整改
      // acceptanceStatus 验收状态
    }
  },
  created() {
    const id = this.$route.query.id
    this.getStep(id)
  },
  methods: {
    async getStep(id) {
      const [err, res] = await hiddenDangerRectificationChecklistApi.get(id)
      console.log('res', res)
      const path = this.findStep(res)
      const query = this.$route.query
      this.$router.replace({
        path,
        query,
      })
    },
    findStep(data) {
      // 驳回
      //   if (data.hazardVerificationStatus === 2) {
      //     return 'hidden-list'
      //   }
      // 即查即改这个字段为null 也要看下一步
      if (data.hazardVerificationStatus !== 1 && data.hazardVerificationStatus !== null) {
        return 'hidden-verify'
      }
      if ([0, 1, 3, 4].includes(data.hiddenDangerRectificationStatus)) {
        return 'hidden-Rectification'
      }
      return 'hidden-Accept'
    },
  },
}
</script>

<style></style>
